export default "__VITE_ASSET__BrE$q_D3__"